import React, { useState } from 'react';
import { PILLARS } from '../data/mock';
import { ArrowUpRight } from 'lucide-react';
import Section, { Reveal } from './Section';

export default function PlatformPillars() {
  const [active, setActive] = useState(0);
  return (
    <Section
      id="ecosystem"
      eyebrow="The Ecosystem"
      title={(
        <>
          One Flywheel.<br />Four Pillars.
        </>
      )}
      lead="Learn in the Academy. Connect in the Marketplace. Perform at the Rallies. Build inside the Network. Each pillar feeds the next, and that's how SAMZ creates a creative economy that compounds."
    >
      <div className="flex items-center gap-6 lg:gap-10 border-b border-white/10 mb-12 overflow-x-auto no-scrollbar">
        {PILLARS.map((p, i) => (
          <button
            key={p.tag}
            onClick={() => setActive(i)}
            className={`tab-underline whitespace-nowrap text-[13.5px] font-medium uppercase tracking-[0.14em] ${active === i ? 'active' : ''}`}
          >
            0{i + 1} &nbsp;{p.tag}
          </button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 80}>
            <a
              href={p.href}
              className={`card-border rounded-2xl p-7 h-full flex flex-col justify-between min-h-[300px] group ${
                active === i ? 'border-[#22A773]/55' : ''
              }`}
            >
              <div>
                <div className="pin-num mb-6">0{i + 1}</div>
                <h3 className="font-display text-white text-[26px] leading-[1.05] tracking-[-0.02em] mb-4">
                  {p.title}
                </h3>
                <p className="text-white/65 text-[13.5px] leading-[1.65]">{p.body}</p>
              </div>
              <div className="mt-7 flex items-center justify-between">
                <span className="text-[#CFA153] text-[12px] tracking-[0.14em] uppercase">Explore</span>
                <span className="w-8 h-8 rounded-full border border-white/15 flex items-center justify-center group-hover:border-[#22A773] group-hover:bg-[#22A773]/10 transition-all">
                  <ArrowUpRight size={14} className="text-white group-hover:text-[#22A773] transition" />
                </span>
              </div>
            </a>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
